/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

const APP_MODE = {
    AVAILABLE_TO_INSTALL: 'available_to_install',
    AVAILABLE_UPDATES: 'available_updates',
    INSTALLED: 'installed',
    INCOMPATIBLE: 'incompatible',
    INCOMPATIBLE_APPS: 'incompatible_apps',
    ACTIVE_SESSIONS: 'active_sessions',
    WEB_APPS: 'services',
    MOBILE_APPS: 'mobile_apps',
};

const MODIFYIING_OPERATION_TYPES = {
    INSTALL: 'install',
    FULL_APP_UPDATE: 'NewVersionUpdate',
    PATCH_UPDATE: 'PatchUpdate',
};

const ENTITLEMENTS = {
    NO_ENTITLEMENT: 'NO_ENTTILEMENT',
    TRIAL_AVAILABLE: 'TRIAL_AVAILABLE',
    TRIAL_NOT_AVAILABLE: 'TRIAL_NOT_AVAILABLE',
    TRIAL_ACTIVE: 'TRIAL_ACTIVE',
    TRIAL_EXPIRED: 'TRIAL_EXPIRED',
    LICENSE_ACTIVE: 'LICENSE_ACTIVE',
    LICENSE_EXPIRED: 'LICENSE_EXPIRED',
    INFORMATION_NOT_AVAILABLE: 'INFORMATION_NOT_AVAILABLE',
    NOT_FETCHED: 'NOT_FETCHED',
};

const UPDATE_TYPE = {
    FULL_APP_UPDATE: 'NewVersionUpdate',
    FULL_BUILD_UPDATE: 'FullBuildUpdate',
    PATCH_UPDATE: 'PatchUpdate',
};

const ACTIVE_SESSIONS_STATUS = {
    FAILED: 'failed',
    CANCELLING: 'cancelling',
    WAITING: 'waiting',
    EXTRACTING: 'extracting',
    INPROGRESS: 'inprogress',
    COMPLETED: 'completed',
    SIMULATED: 'active_simulated',
};

const TRIAL_STATUS = {
    COMPLETED: 'Completed',
    FAILED: 'Failed',
};

const ACTION_IN_PROGRESS = {
    INSTALL: 'install',
    UPDATE: 'update',
    UNINSTALL: 'uninstall',
    SIMULATED: 'simulated',
    START_TRIAL: 'startTrial',
};

const LICENSE_MODE = {
    FREEMIUM: 'freemium',
    PAID: 'paid',
};

export {
    APP_MODE,
    ENTITLEMENTS,
    UPDATE_TYPE,
    ACTIVE_SESSIONS_STATUS,
    TRIAL_STATUS,
    ACTION_IN_PROGRESS,
    MODIFYIING_OPERATION_TYPES,
    LICENSE_MODE,
};
